export function flatten<T>(items: T[][]) {
	return ([] as T[]).concat(...items);
}
